export const faqList = [
  {
    id: "f1",
    q: "为什么之前收藏的网址突然打不开？",
    a: "入口域名会不定期更换，旧地址失效是常见情况。先回到本页刷新查看「线路状态」表，挑选状态为「顺畅」的最新地址即可继续访问。",
  },
  {
    id: "f2",
    q: "本站和 51黑料网 是什么关系？",
    a: "本页是用于整合入口信息的导航页面，汇总官网、最新地址、网址与 app 安装方式，帮助用户快速定位当前可用的访问渠道，本身不提供、不生产任何具体内容。",
  },
  {
    id: "f3",
    q: "手机端打不开该怎么处理？",
    a: "优先选择标注为「移动优选」的线路，或者尝试切换 Wi-Fi 与移动数据网络；若仍然打不开，换一条备用线路通常即可恢复。",
  },
  {
    id: "f4",
    q: "App 安装需要注意什么？",
    a: "安装前请确认系统存储空间充足，安卓侧如提示来源限制，可手动允许安装；iOS 端建议按页面给出的方式添加后再打开。",
  },
  {
    id: "f5",
    q: "怎样才能第一时间拿到最新地址？",
    a: "把本导航页加入浏览器书签或添加到主屏幕，地址每次变动后本页会同步更新，直接刷新即可，无需在多个渠道之间来回寻找。",
  },
  {
    id: "f6",
    q: "页面上的按钮点进去会打开什么？",
    a: "页面展示的地址、状态与更新时间为演示用的静态信息，按钮用于演示复制、切换与查看的交互效果，不会触发真实跳转或提交。",
  },
];